<template>
  <div id="feedback-list">
    <form class="row search-pannel" :class="{ fold: fold}" @submit.prevent="doLoad(true)">
      <input type="submit" style="display:none" />
      <div class="col-sm-5">
        <el-select size="small" v-model="query.type" placeholder="类型">
          <el-option label="配件券" :value="1" />
          <el-option label="服务券" :value="2" />
        </el-select>
      </div>
      <div class="col-sm-5">
        <el-input size="small" v-model="query.companyName" placeholder="客户名称" />
      </div>
      <div class="col-sm-5">
        <el-select size="small" v-model="query.state" placeholder="状态" clearable>
          <el-option v-for="ft in couponStates" :key="ft.id" :label="ft.name" :value="ft.id"></el-option>
        </el-select>
      </div>
      <div class="col-sm-4" v-if="query.state===2" style="line-height: 32px">
        <el-checkbox v-model="query.expiring">即将过期</el-checkbox>
      </div>
      <div class="col-sm-5 folder">
        <el-button type="primary" size="small" @click="doLoad(true)">确定</el-button>
        <el-button type="default" size="small" @click="doReset">重置</el-button>
        <el-button style="float: right" size="small" type="text" @click="fold = !fold">
          {{ fold ? '展开' : '收起' }}
          <i v-if="fold" class="crm-icon-arrow-down" />
          <i v-else class="crm-icon-arrow-up" />
        </el-button>
      </div>
    </form>
    <div class="data-header">
      <div class="row" :style="{ paddingRight: hasScroll ? 10 + scrollBarWidth + 'px' : 'px' }">
        <div class="col-sm-3">客户名称</div>
        <div class="col-sm-2">券类型</div>
        <div class="col-sm-3">券名称</div>
        <div class="col-sm-2">券面额</div>
        <div class="col-sm-2">发放日期</div>
        <div class="col-sm-2">领取方式</div>
        <div class="col-sm-2">领取人</div>
        <div class="col-sm-2">领取日期</div>
        <div class="col-sm-2">生效日期</div>
        <div class="col-sm-2">失效日期</div>
        <div class="col-sm-2">状态</div>
      </div>
    </div>
    <div ref="dataList" class="data-list">
      <template v-if="list && list.length">
        <div v-for="item in list" :key="item.id" class="feedback-item-wraper">
          <div class="feedback-item row">
            <div class="col-sm-3">
              <label>客户名称</label>
              <div>{{ item.companyName }}</div>
            </div>
            <div class="col-sm-2">
              <label>券类型</label>
              <div>
                {{ item.couponType === 2 ? '服务券' : '配件券' }}
              </div>
            </div>
            <div class="col-sm-3">
              <label>券名称</label>
              <div>{{ item.couponName }}</div>
            </div>
            <div class="col-sm-2">
              <label>券面额</label>
              <div>
                {{ item.couponAmount }}
              </div>
            </div>
            <div class="col-sm-2">
              <label>发放日期</label>
              <div>
                {{ item.issueDate | dateFmt }}
              </div>
            </div>
            <div class="col-sm-2">
              <label>领取方式</label>
              <div>
                {{ item.receiveType === 2 ? '手动' : '自动' }}
              </div>
            </div>
            <div class="col-sm-2">
              <label>领取人</label>
              <div>{{ item.receiver || '系统' }}</div>
            </div>
            <div class="col-sm-2">
              <label>领取日期</label>
              <div v-if="item.receiveDate">{{ item.receiveDate | dateFmt }}</div>
              <div v-else>--</div>
            </div>
            <div class="col-sm-2">
              <label>生效日期</label>
              <div v-if="item.effectiveDate">{{ item.effectiveDate | dateFmt }}</div>
              <div v-else>--</div>
            </div>
            <div class="col-sm-2">
              <label>失效日期</label>
              <div v-if="item.expirationDate">{{ item.expirationDate | dateFmt }}</div>
              <div v-else>--</div>
            </div>
            <div class="col-sm-2">
              <label>状态</label>
              <div>
                {{ item.customerCouponState | couponStateFmt }}
              </div>
            </div>
          </div>
        </div>
      </template>
      <div v-else class="no-data">
        暂无数据~
      </div>
    </div>
    <div class="page-footer">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page.sync="pagination.pageIndex"
        :total="pagination.totalCount"
        :page-size="pagination.pageSize"
        @current-change="doLoad(false)"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { couponStates, listCoupon } from './services'
import { bind, unbind } from '@/utils/eventBinder.js'
import _ from 'lodash'
import moment from 'moment'
export default {
  name: 'Coupon',
  filters: {
    couponStateFmt (val) {
      const t = couponStates.find(t => t.id === val)
      return (t && t.name) || '--'
    }
  },
  data () {
    return {
      loading: false,
      list: [],
      query: {
        companyName: undefined,
        type: undefined,
        state: undefined,
        expiring: false
      },
      couponStates,
      fold: true,
      hasScroll: false,
      pagination: {
        totalCount: 0,
        pageIndex: 1,
        pageSize: 30
      }
    }
  },
  computed: {
    renderRow () {
      return this.list.length
    },
    scrollBarWidth () {
      return this.$store.state.scrollbarWidth
    }
  },
  watch: {
    renderRow () {
      this.$nextTick(() => {
        this.checkScrollbar()
      })
    },
    newAdd () {
      this.doLoad(true)
    },
    area () {
      this.doLoad(true)
    }
  },
  mounted () {
    this.checkScrollBarDebounce = _.debounce(() => {
      this.checkScrollbar()
    }, 50)
    bind(window, 'resize', this.checkScrollBarDebounce)
    this.doLoad(true)
  },
  beforeDestory () {
    unbind(window, 'resize', this.checkScrollBarDebounce)
  },
  methods: {
    doLoad (reload) {
      if (reload) {
        this.pagination.pageIndex = 1
      }
      this.loading = true
      const { companyName, type, state, expiring } = this.query
      const { pageIndex, pageSize } = this.pagination
      listCoupon({
        state: state || undefined,
        companyName: companyName || undefined,
        couponType: type || undefined,
        expiring: expiring ? moment().add(5, 'd').format('YYYY-MM-DD') : undefined,
        newAdd: this.newAdd,
        area: this.area || undefined,
        pageIndex,
        pageSize
      }).then(resp => {
        const { items, pageIndex, pageSize, totalCount } = resp
        this.list = items
        this.pagination.pageIndex = pageIndex
        this.pagination.pageSize = pageSize
        this.pagination.totalCount = totalCount
      }).finally(() => {
        this.loading = false
      })
    },
    doReset () {
      this.query = {
        state: undefined,
        companyName: undefined,
        type: undefined,
        expiring: false
      }
      this.pagination = {
        pageIndex: 1,
        pageSize: 30,
        totalCount: 0
      }
      this.doLoad(true)
    },
    checkScrollbar () {
      const dataList = this.$refs.dataList
      if (dataList) {
        this.hasScroll = dataList.clientHeight < dataList.scrollHeight
      } else {
        this.hasScroll = false
      }
    }
  }
}
</script>
